import { Component, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { FeedbackService } from 'src/app/core/services/feedback.service';

@Component({
  selector: 'app-acceptance-submitted-thankyou',
  templateUrl: './acceptance-submitted-thankyou.component.html',
  styleUrls: ['./acceptance-submitted-thankyou.component.scss']
})
export class AcceptanceSubmittedThankyouComponent {
  rating = 0;
  hoverRating = 0;
  comment = '';
  submitted = false;
  stars = [1, 2, 3, 4, 5];

  constructor(
    private dialogRef: MatDialogRef<AcceptanceSubmittedThankyouComponent>,
    @Inject(MAT_DIALOG_DATA) private data: { appId: string },
    private feedbackService: FeedbackService
  ) {}

  setRating(n: number) {
    this.rating = n;
  }

  onStarHover(n: number) {
    this.hoverRating = n;
  }

  onStarLeave() {
    this.hoverRating = 0;
  }

  submitFeedback() {
    if (!this.rating) return;
    this.submitted = true;
    const comment = this.comment.trim() || undefined;
    this.feedbackService.submitFeedback(this.data.appId, this.rating, comment)
      .subscribe({ error: () => {} });
    this.dialogRef.close();
  }

  skip() {
    this.dialogRef.close();
  }
}
